import { Question, Tender, TenderAnswer, TenderingIndexing, TenderingPart } from "../models/tendering";

export const getTodayKey = (): string => new Date().toLocaleDateString("sv-SE");

export const toDateKey = (date?: string): string => (date ?? "").slice(0, 10);

export function getRequestedIndexings(tender: Tender, tenderingIndexings: TenderingIndexing[]): TenderingIndexing[] {
  return tenderingIndexings.filter(i => tender.indexing?.some(t => Number(t.indexingID) === i.indexingID));
}

/** Price before/after a given indexing for one answer, or undefined if that indexing hasn't been applied to it. */
export function getIndexingPriceChange(
  indexing: TenderingIndexing,
  questionID: number,
  answer: TenderAnswer | undefined,
  requestedIndexings: TenderingIndexing[]
): { before: number; after: number } | undefined {
  const history = answer?.valueHistory;
  if (!answer || !history || history.length < 2) return undefined;

  const today = getTodayKey();
  const applied = requestedIndexings
    .filter(i => i.prices?.some(p => p.questionID === questionID) && toDateKey(i.indexingDate) <= today)
    .sort((a, b) => toDateKey(a.indexingDate).localeCompare(toDateKey(b.indexingDate)));

  const position = applied.findIndex(i => i.indexingID === indexing.indexingID);
  const appliedCount = history.length - 1;
  if (position < 0 || position >= appliedCount) return undefined;

  const after = position + 1 < appliedCount ? history[position + 2] : answer.value;
  return { before: Number(history[position + 1]), after: Number(after) };
}

export function getQuestionHeader(questionID: number, tenderingParts: TenderingPart[]): string {
    let questions: Question[] = [];
    tenderingParts.forEach(part => {
      questions = [...(part.questions ?? []), ...questions];
    });
    const question = questions.find(q => q.questionID === questionID);

    if (question) {
      return question.heading;
    }
    
    return 'Ingen koppling...';
  }

  export function getQuestionText(questionID: number, tenderingParts: TenderingPart[]): string {
    let questions: Question[] = [];
    tenderingParts.forEach(part => {
      questions = [...(part.questions ?? []), ...questions];
    });
    const question = questions.find(q => q.questionID === questionID);

    if (question) {
      return question.text;
    }
    
    return 'Ingen koppling...';
  }

  export function getPriceAnswer(questionID: number, tenderAnswers: TenderAnswer[]): number | undefined{
    const answer = tenderAnswers.find(a => a.questionID === questionID);
    if (answer) {
      return Number(answer.value);
    }
    else {
      return undefined;
    }
  }